export default "__VITE_ASSET__CrLBY4ay__"